import { Cookie } from '@vue-util/cookie';
import logger from '@core/util/universal-logger';

const BRAND = (process.env.ENTRY_POINT === 'mcom') ? 'macys' : 'bloomingdales';
const USER_ID = `${BRAND}_online_uid`;

export default (response) => {
  // Thirty days in milleseconds - 2592000000;
  // One day in milleseconds - 86400000;
  const expiresInADay = new Date(new Date().getTime() + 86400000);
  const is365Customer = (Cookie.get('Login365Customer', 'MISCGCs') === 'Y');
  const expiryExtension = is365Customer ? 31556952000 : 2592000000;
  const cookieExpiry = new Date().getTime() + expiryExtension;
  const expires = new Date(cookieExpiry);

  const {
    bag: {
      meta: {
        dca, userId, bagGuid, userGuid, xMacysWrapperId, bagAttributes: { bagItemQuantity } = {},
      } = {},
    } = {},
  } = response;

  if (userId) {
    Cookie.set(USER_ID, userId, undefined, { expires });
  }

  const userIdCookie = Cookie.get(USER_ID);
  // If userId is not present in Cookie, redirect the user to nosession page
  if (!userIdCookie) {
    window.location.assign('/nosessioncookie.jsp');
    return false;
  }

  if (userGuid) {
    Cookie.set(`${BRAND}_online_guid`, userGuid, undefined, { expires });
  }
  if (bagGuid) {
    Cookie.set(`${BRAND}_bagguid`, bagGuid, undefined, { expires });
  }

  if (dca) {
    Cookie.set('dca', dca, undefined, { expires: expiresInADay });
  }
  if (xMacysWrapperId) {
    Cookie.set('bag_wrapper_id', xMacysWrapperId, undefined, { expires: expiresInADay });
  }

  // If quantity is not present , then there is some issue from api, so log error
  // If quantity exists , save it GC's cookie and inform other apps
  if (bagItemQuantity || bagItemQuantity === 0) {
    // Set new bag itemCount
    Cookie.set('CartItem', bagItemQuantity, 'GCs');
    // Dispatch event to apps listening to this
    window.dispatchEvent(new CustomEvent('updateQuickBagCount', { detail: bagItemQuantity }));
  } else {
    logger.error(`Bag response does not contain bagItemQuantity , bagItemQuantity:${bagItemQuantity}`);
  }

  return true;
};
